var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuaijia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 673",
    d: "M11.1034 7.07233V9.97559L8.49219 11.6935",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 671",
    d: "M6.92871 7.93127L15.9306 12.8789",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 668",
    d: "M11.0178 7.0036L15.9654 9.82097V12.8789L13.1824 14.3906M13.1824 14.3906L8.25195 11.5045M13.1824 14.3906V11.5045L8.33785 8.70433",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 669",
    d: "M13.0791 11.6076L16.0683 9.82098",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 670",
    d: "M6.99771 1.7468V7.99999L1.70654 10.9204",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 665",
    d: "M12.2545 7.48463V4.73597L6.99767 1.60938L1.43164 4.73597V10.9204L6.99767 14.2532L10.0212 12.5353",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 666",
    d: "M1.46582 4.83905L6.92877 8L12.4261 4.83905",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 667",
    d: "M6.94629 7.93127V14.0814",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 672 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2839 6.48093L12.2027 7.10669L9.05894 9.1012V12.6555L7.95947 11.9512V8.47929L11.2839 6.48093Z",
    fill: "#2F88FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuaijia);
export default __webpack_public_path__ + "static/media/kuaijia.cb9eeecd50682545746d3a6c89b596a7.svg";
export { ForwardRef as ReactComponent };